import { render, staticRenderFns } from "./SingleNumberFrameTablets.vue?vue&type=template&id=59aec0e4&"
import script from "./SingleNumberFrameTablets.vue?vue&type=script&lang=js&"
export * from "./SingleNumberFrameTablets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports